import { Box, FormGroup, Modal, Typography, IconButton, Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MessageIcon from "@mui/icons-material/Message";
import SendIcon from "@mui/icons-material/Send";
import { fontSize } from "../theme/fontSize";
import { fontWeight } from "../theme/fontWeight";
import { FontFamily } from "../theme/fontFamily";
import { ThemeColor } from "../theme/color";
import { Formik, Form } from "formik";
import CustomButton from "../button/button";
import OutlinedInputField from "../inputfiled/OutlinedInput";
import moment from "moment";
import * as Yup from "yup";
import AttachmentDropzone from "../dropzone/AttachmentDropzone";
import { GetStudentChatByIdAction } from "../../Redux/action/ApplicationAction";
import {
  AddStudentChatService,
  postmarkSeenMessagesStdAPI,
} from "../../Redux/service/Application";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SOCKET_EVENTS from "../../socket/events";
import { connectSocket, getSocket } from "../../socket/socketClient";


const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "85%", md: "650px" },
  height: "75vh",
  maxHeight: "650px",
  bgcolor: "#FFFFFF",
  borderRadius: "16px",
  boxShadow: "0 20px 50px rgba(0, 0, 0, 0.15)",
  border: "none",
  outline: "none",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

const validationSchema = Yup.object({
  message: Yup.string().when("fileUrl", {
    is: (fileUrl) => !fileUrl || fileUrl.length === 0,
    then: (schema) => schema.required("Either text or file is required to send message"),
    otherwise: (schema) => schema.notRequired(),
  }),
  fileUrl: Yup.array().notRequired(),
});

export const StudentChatModal = ({ chatModal, handleClose, stdId, Studentlist }) => {
  const dispatch = useDispatch();
  const [ChatByIdlist, setChatByIdlist] = useState([]);
  const messagesEndRef = useRef(null);

  const childRef = useRef();

  const [AttachedFiles, setAttachedFiles] = useState([]);

  const ChatByIdlistState = useSelector(
    (state) => state.application?.studentchat?.data?.data?.[0]
  );

  useEffect(() => {
    setChatByIdlist(ChatByIdlistState);
  }, [ChatByIdlistState]);

  useEffect(() => {
    if (chatModal && stdId) {
      dispatch(GetStudentChatByIdAction(stdId));
    }
  }, [chatModal, stdId, dispatch]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [ChatByIdlist?.messages]);


  useEffect(() => {
    if (!chatModal || !stdId) return;

    const socket = connectSocket();
    if (!socket) return;

    socket.emit(SOCKET_EVENTS.STUDENT_CHAT_JOIN, { studentId: stdId });

    const handleNewMessage = (payload) => {
      if (String(payload?.studentId) === String(stdId) && payload?.message) {
        setChatByIdlist((prev) => {
          if (!prev) return prev;
          const messages = prev.messages || [];
          const exists = messages.some(
            (m) => String(m._id) === String(payload.message._id)
          );
          if (exists) return prev;
          return {
            ...prev,
            messages: [...messages, payload.message],
          };
        });

        const currentUserId = window.sessionStorage.getItem("user_id");
        const senderId = String(
          payload.message?.sender?._id || payload.message?.sender || ""
        );
        if (currentUserId && senderId !== String(currentUserId)) {
          postmarkSeenMessagesStdAPI(stdId).catch(() => {});
        }
      }
    };

    socket.on(SOCKET_EVENTS.STUDENT_CHAT_MESSAGE_NEW, handleNewMessage);

    return () => {
      socket.emit(SOCKET_EVENTS.STUDENT_CHAT_LEAVE, { studentId: stdId });
      socket.off(SOCKET_EVENTS.STUDENT_CHAT_MESSAGE_NEW, handleNewMessage);
    };
  }, [chatModal, stdId]);


  const currentStudent = Studentlist?.find(
    (data) => data.id === stdId || data._id === stdId
  );
  const studentFirstName =
    ChatByIdlist?.student?.studentFirstName ||
    currentStudent?.studentFirstName ||
    currentStudent?.firstName ||
    "";
  const studentLastName =
    ChatByIdlist?.student?.studentLastName ||
    currentStudent?.studentLastName ||
    currentStudent?.lastName ||
    "";
  const fullStudentName = `${studentFirstName} ${studentLastName}`.trim();

  const downloadFile = (file) => {
    window.open(file, "_blank", "noopener noreferrer");
  };

  const FileHandler = (data) => {
    return (
      data?.fileUrl?.length > 0 &&
      data.fileUrl.map((fileUrl, index) => {
        const fileExtension = fileUrl?.split(".").pop().toLowerCase();
        const urlParts = fileUrl?.split("/");
        const fullFileName = urlParts[urlParts.length - 1];

        if (fileExtension === "xlsx") {
          return (
            <div key={index} className="mt-2 d-flex align-items-center">
              <div className="filename-icon" style={{ width: 24, height: 24 }}>
                <img
                  src="/assest/folderpng/excel.png"
                  alt="file icon"
                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                />
              </div>
              <a
                href={fileUrl}
                download={fullFileName}
                style={{ textDecoration: "none", color: ThemeColor.PURPLE }}
              >
                <Typography
                  className="px-2"
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W500}
                  fontSize="0.85rem"
                >
                  {fullFileName}
                </Typography>
              </a>
            </div>
          );
        } else if (fileExtension === "docx" || fileExtension === "doc") {
          return (
            <div className="mt-2 d-flex align-items-center" key={index}>
              <div className="filename-icon" style={{ width: 24, height: 24 }}>
                <img
                  src="/assest/folderpng/word.png"
                  alt="Word Icon"
                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                />
              </div>
              <a
                href={fileUrl}
                download={fullFileName}
                style={{ textDecoration: "none", color: ThemeColor.PURPLE }}
              >
                <Typography
                  className="px-2"
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W500}
                  fontSize="0.85rem"
                >
                  {fullFileName}
                </Typography>
              </a>
            </div>
          );
        } else if (fileExtension === "pdf") {
          return (
            <div key={index} className="mt-2 d-flex align-items-center">
              <div className="filename-icon" style={{ width: 24, height: 24 }}>
                <img
                  src="/assest/folderpng/pdf.png"
                  alt="file icon"
                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                />
              </div>
              <a
                href={fileUrl}
                target="_blank"
                download={fullFileName}
                rel="noreferrer"
                style={{ textDecoration: "none", color: ThemeColor.PURPLE }}
              >
                <Typography
                  className="px-2"
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W500}
                  fontSize="0.85rem"
                >
                  {fullFileName}
                </Typography>
              </a>
            </div>
          );
        } else {
          return (
            <div key={index} className="mt-2">
              <img
                onClick={() => downloadFile(fileUrl)}
                src={fileUrl}
                style={{
                  width: "120px",
                  height: "120px",
                  borderRadius: "8px",
                  objectFit: "cover",
                  cursor: "pointer",
                }}
                alt="chatimg"
              />
            </div>
          );
        }
      })
    );
  };

  return (
    <Modal
      open={chatModal}
      onClose={() => handleClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyle}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 2,
            bgcolor: ThemeColor.PURPLE,
            color: "#FFFFFF",
          }}
        >
          <Box display="flex" alignItems="center" gap={1.5}>
            <MessageIcon sx={{ color: "#FFF", fontSize: 22 }} />
            <Typography
              fontFamily={FontFamily.Poppins}
              fontWeight={fontWeight.W600}
              fontSize={fontSize.h3.medium}
              color="#FFFFFF"
            >
              {fullStudentName ? `Chat for "${fullStudentName}"` : "Chat"}
            </Typography>
          </Box>
          <IconButton
            onClick={() => handleClose()}
            size="small"
            sx={{
              color: "#FFFFFF",
              bgcolor: "rgba(255, 255, 255, 0.15)",
              "&:hover": { bgcolor: "rgba(255, 255, 255, 0.3)" },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* Message Stream */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            px: 3,
            py: 2.5,
            backgroundColor: "#F8FAFC",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            '&::-webkit-scrollbar': { width: '6px' },
            '&::-webkit-scrollbar-track': { background: '#F1F5F9' },
            '&::-webkit-scrollbar-thumb': { background: '#CBD5E1', borderRadius: '10px' },
            '&::-webkit-scrollbar-thumb:hover': { background: '#94A3B8' },
          }}
        >
          {ChatByIdlist?.messages?.map((data, index) => {
            const isSender = data.sender?._id === window.sessionStorage.getItem("user_id");
            return (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: isSender ? "flex-end" : "flex-start",
                  maxWidth: "80%",
                  alignSelf: isSender ? "flex-end" : "flex-start",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 0.5,
                    px: 0.5,
                  }}
                >
                  <Typography
                    fontFamily={FontFamily.Poppins}
                    fontWeight={fontWeight.W600}
                    fontSize="0.75rem"
                    color={isSender ? ThemeColor.PURPLE : ThemeColor.BLACK}
                  >
                    {data.sender?.firstName} {data.sender?.lastName}
                  </Typography>
                  <Typography
                    fontFamily={FontFamily.Poppins}
                    fontSize="0.7rem"
                    color="#94A3B8"
                  >
                    {moment.unix(data.dateTime).format("MMM D, h:mm A")}
                  </Typography>
                </Box>

                <Paper
                  elevation={0}
                  sx={{
                    px: 2.5,
                    py: 1.5,
                    borderRadius: isSender ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
                    bgcolor: isSender ? ThemeColor.PURPLE : "#FFFFFF",
                    color: isSender ? "#FFFFFF" : "#1E293B",
                    border: isSender ? "none" : "1px solid #E2E8F0",
                    boxShadow: isSender
                      ? "0 4px 12px rgba(99, 102, 241, 0.15)"
                      : "0 2px 6px rgba(0, 0, 0, 0.04)",
                  }}
                >
                  {data?.fileUrl && <Box mb={data.message ? 1 : 0}>{FileHandler(data)}</Box>}
                  {data.message && (
                    <Typography
                      fontFamily={FontFamily.Poppins}
                      fontWeight={fontWeight.W400}
                      fontSize="0.9rem"
                      lineHeight={1.4}
                      color="inherit"
                      sx={{
                        wordBreak: "break-word",
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {data.message}
                    </Typography>
                  )}
                </Paper>
              </Box>
            );
          })}
          <div ref={messagesEndRef} />
        </Box>

        {/* Form Footer */}
        <Formik
          initialValues={{
            message: "",
            fileUrl: [],
          }}
          validationSchema={validationSchema}
          onSubmit={async (values, { resetForm }) => {
            const fileUrl = values.fileUrl?.map((data) => data.url);

            await AddStudentChatService({
              message: values.message,
              fileUrl: fileUrl,
              chatRoomId: ChatByIdlist?._id,
              student: stdId,
            })
              .then((res) => {
                if (res.status === 200) {
                  dispatch(GetStudentChatByIdAction(stdId));
                  setAttachedFiles([]);
                  if (childRef.current) {
                    childRef.current.resetDropzone();
                  }
                  resetForm();
                }
              })
              .catch((e) => {
                console.error("Error sending message:", e);
              });
          }}
        >
          {({ values, errors, handleChange, handleSubmit, setFieldValue }) => (
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{
                p: 2,
                bgcolor: "#FFFFFF",
                borderTop: "1px solid #E2E8F0",
              }}
            >
              {AttachedFiles && AttachedFiles.length > 0 && (
                <Box mb={1} px={1}>
                  {AttachedFiles.map((file, idx) => (
                    <Typography
                      key={idx}
                      color={ThemeColor.PURPLE}
                      fontSize="0.8rem"
                      fontFamily={FontFamily.Poppins}
                    >
                      Selected file: {file?.name}
                    </Typography>
                  ))}
                </Box>
              )}
              <Box display="flex" alignItems="center" gap={1.5}>
                <Box flex={1}>
                  <OutlinedInputField
                    value={values.message}
                    name={"message"}
                    onChange={handleChange}
                    placeholder="Write something..."
                    fullWidth={true}
                    helperText={errors.message}
                  />
                </Box>
                <AttachmentDropzone
                  ref={childRef}
                  handleMydropzoneFile={(updatedFiles, files) => {
                    setAttachedFiles(files);
                    setFieldValue("fileUrl", updatedFiles);
                  }}
                />
                <CustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  color={ThemeColor.WHITE}
                >
                  Send
                </CustomButton>
              </Box>
            </Box>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};
